import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ScanBarcode } from "lucide-react";
import React from "react";

interface RefusedArticleScannerProps {
  onScan: (barcode: string) => void;
}

const RefusedArticleScanner: React.FC<RefusedArticleScannerProps> = ({
  onScan,
}) => {
  const [barcode, setBarcode] = React.useState("");

  const handleScan = () => {
    if (!barcode) return;
    onScan(barcode);
    setBarcode("");
  };

  return (
    <div className="px-4 flex flex-col gap-2">
      <div className="flex items-center justify-between gap-2">
        <Input
          placeholder="Scanner les articles refusés uniquement"
          className="w-full h-10"
          value={barcode}
          onChange={(e) => setBarcode(e.target.value.trim())}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleScan();
            }
          }}
        />
        <Button variant="outline" className="h-10" onClick={handleScan}>
          <ScanBarcode className="h-6 w-6" />
        </Button>
      </div>
      <p className="text-xs text-muted-foreground">
        Scannez uniquement les articles refusés, les articles non scannés seront
        acceptés automatiquement.
      </p>
    </div>
  );
};

export default RefusedArticleScanner;
